import { Flex, Skeleton, Text } from '@radix-ui/themes';
import { PropsWithChildren } from 'react';

const lorem = [
    'Lorem, ipsum dolor sit amet consectetur adipisicing elit.',
    'Vero quasi beatae libero sequi laborum delectus consequuntur aspernatur nemo dolore repudiandae ?',
    'Unde, natus, quae modi vero ut veniam laudantium culpa saepe a quidem deleniti est.',
    'Eligendi repellendus quam quas.',
    'Perspiciatis magnam, possimus architecto iure similique expedita!',
    'Sed, placeat!',
    'At, amet aliquid ipsum doloremque id consequuntur atque deleniti, laboriosam soluta non illum ?',
    'Expedita illo similique quod, tempora hic et neque incidunt non consequatur libero ?',
    'Laboriosam optio quia laudantium nemo eligendi eum itaque.',
    'Quam sequi repellendus, rem hic optio libero quos at aliquid.',
    'Accusamus voluptatibus magni natus illum eius voluptate similique qui quaerat.',
    'Nisi explicabo sapiente omnis, consequuntur ex aliquid odit velit nihil vel iste quo hic quibusdam, delectus magni reprehenderit.',
    'Nemo, necessitatibus.',
    'Libero numquam dolorum debitis eligendi ipsa quod alias velit minus omnis distinctio a, magnam quasi, deleniti provident, recusandae et in.',
    'Iure non repellendus error ab dicta quod.',
    'Quia nostrum id minus adipisci reprehenderit, assumenda dolor dolore corrupti quam fugit inventore ?',
    'Nemo fugit mollitia debitis ab dolorem quas sed alias, error ut voluptates, quisquam nulla, vel necessitatibus veniam quis labore modi.',
    'Inventore similique ex, eaque odit distinctio modi, incidunt aspernatur accusamus ducimus perspiciatis odio iusto dolor facere magni accusantium rerum ad.',
] as const;

interface TextBlockSkeletonProps extends PropsWithChildren {
    size?: number;
    loading: boolean;
}

export const TextBlockSkeleton = ({
    size = 1,
    loading,
    children,
}: TextBlockSkeletonProps) => {
    if (!loading) return children;

    const lines = lorem.slice(0, size);
    return (
        <Flex direction={'column'}>
            {lines.map((line, i) => {
                return (
                    <Text key={i} wrap={'pretty'}>
                        <Skeleton>{line}</Skeleton>
                    </Text>
                );
            })}
        </Flex>
    );
};
